import React from "react";
import DataTableBase from "./dataTableBase";
import { deviceColumns } from "./columnDefs";

export default function DevicesTable({ devices = [] }) {
  return (
    <DataTableBase
      title={"Devices"}
      data={devices}
      columns={deviceColumns}
      orderby="time_created"
      orderdirection="desc"
    />
  );
}
